export default "__VITE_ASSET__830716b7__"